import {
  Button,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useLocalizedWorkingStepLabel } from 'components/Localization/useLocalizedWorkingStepLabel'
import { useTranslation } from 'react-i18next'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ReactComponent as FilterIconSvg } from '_icons/project-menu/filter.svg'
import { useWorkingStepFilter } from './useWorkingStepFilter'
import './WorkingStepsFilter.scss'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    activeFilter: {
      textAlign: 'center',
      '& .MuiIconButton-root': {
        backgroundColor: theme.palette.info.light,
        '&:hover': {
          backgroundColor: theme.palette.info.dark,
        },
      },
    },
  })
)

const IconComponent = (props: { selectedFilter: WorkingStepType | null }) => {
  if (props.selectedFilter === WorkingStepType.NotInitialized)
    return (
      <span className="icon">
        <FilterIconSvg />
      </span>
    )

  return (
    <span className="icon">
      <WorkingStepIconSvg workingStepType={props.selectedFilter} />
    </span>
  )
}

export const WorkingStepsFilter = () => {
  const cn = useStyles()
  const { t } = useTranslation()
  const { getLocalizedWorkingStep } = useLocalizedWorkingStepLabel()

  const { workingStepFilter, handleChangeFilter } = useWorkingStepFilter()

  return (
    <div className="filter-container">
      <div className="working-steps-filter-selector">
        {workingStepFilter.filter.availableFilters.map((workingStepType) => {
          const isActiveFilter =
            workingStepFilter.active &&
            workingStepFilter.filter.enabledFilters?.includes(workingStepType)
          return (
            <div
              className={`working-step-filter-button ${
                isActiveFilter ? cn.activeFilter : ''
              }`}
              key={workingStepType}
            >
              <IconButton
                onClick={() => handleChangeFilter(workingStepType)}
                size="medium"
                // disabled={!workingStepFilter.active}
                className={`${isActiveFilter ? cn.activeFilter : ''}`}
                id={`btn-ws-filter-${workingStepType}`}
              >
                <IconComponent selectedFilter={workingStepType} />
              </IconButton>
              <Typography
                variant="body2"
                color={
                  `${isActiveFilter ? 'textPrimary' : 'textSecondary'}` as never
                }
                component="label"
                htmlFor={`btn-ws-filter-${workingStepType}`}
                style={{ cursor: 'pointer' }}
              >
                {getLocalizedWorkingStep(workingStepType)}
              </Typography>
            </div>
          )
        })}
      </div>
      <div className="filter-actions">
        {workingStepFilter.active &&
          !workingStepFilter.filter.enabledFilters?.length && (
            <LocalizedTypography
              translationKey={'project:filter-empty-working-steps'}
              variant="caption"
              color="secondary"
            >
              filtering parts without any working steps
            </LocalizedTypography>
          )}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleChangeFilter(WorkingStepType.NotInitialized)}
          // disabled={!workingStepFilter.active}
        >
          {t('common:none')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleChangeFilter()}
          // disabled={!workingStepFilter.active}
        >
          {t('common:all')}
        </Button>
      </div>
    </div>
  )
}
